/*eslint-disable */
import Vue from 'vue'
import App from './App/index';
import VueRouter from 'vue-router';
import router from './route';
import store from './store/store.js';
import customDirective from './_helpers/custom.directive';
import VeeValidate from 'vee-validate';
import interceptor from './services/interceptor';
import timestamp from './services/timestamp';
import axios from 'axios';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// Highlight.js languages (Only required languages)
import highlightjs from './services/highlightjs';
import VueHighlightJS from 'vue-highlightjs'
import 'highlight.js/lib/languages/css';
import './assets/fonts/myrid-pro/stylesheet.css';
import 'highlight.js/lib/languages/javascript';
// import 'highlight.js/styles/atom-one-dark.css';
import'highlight.js/styles/a11y-dark.css';
import "vue-tel-input/dist/vue-tel-input.css";

Vue.config.productionTip = false;
Vue.use(VueRouter, axios);
Vue.use(VeeValidate, {
  validity: true
});

// SynTaxHighlighter Register only languages that you want
Vue.use(VueHighlightJS)
// Bus
export const bus = new Vue();

const token = localStorage.getItem('token');

if (token != '' && token != null) {
  axios.defaults.headers.common['Authorization'] = 'Token ' + localStorage.getItem('token');
}
var $ = window.jQuery = require('jquery');
store.dispatch('getAuthHeader');

if (navigator.userAgent.indexOf('Mac') > 0) {
  $('body').addClass('mac');
}
new Vue({
  render: h => h(App),
  router: router,
  store: store,
  interceptor,
  timestamp,
  highlightjs
}).$mount('#app')
